import { get, map, isEmpty, remove, cloneDeep, set, concat } from 'lodash-es';
import uuidv4 from 'uuid/v4';
import { checkIsNull } from '../../Utils/utils';
import { getLastSequenceOfQuestions } from './QuotationBlock.utils';
import * as types from './QuotationBlock.actionTypes';

/**
 * set Show Partie by id
 * @param {*} param0
 */
const setShowPartie = ({ data, id }) => {
  try {
    const newData = map(data, partiesItem => {
      const partie = cloneDeep(partiesItem);
      if (get(partie, 'id') === id) {
        const show = get(partie, 'show');
        set(partie, 'show', !show);
      }
      return partie;
    });
    return newData;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setShowPartie: ${e.stack}`);
  }
  return data;
};

/**
 * remove ayant droit by ID part
 * @param {*} param0
 */
const removePartie = ({ data, id }) => {
  try {
    const dataClone = cloneDeep(data);
    const deletedObject = remove(dataClone, { id });
    if (!isEmpty(deletedObject)) {
      return dataClone;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`removePartie: ${e.stack}`);
  }
  return data;
};

/**
 * set Show Group by id
 * @param {*} param0
 */
const setShowGroup = ({ data, idPartie, idGroup }) => {
  try {
    // get group item
    const getGroupItem = groupsItem => {
      const group = cloneDeep(groupsItem);
      if (idGroup === get(group, 'id')) {
        const show = get(group, 'show');
        set(group, 'show', !show);
      }
      return group;
    };

    // map parties
    const newData = map(data, partiesItem => {
      const partie = cloneDeep(partiesItem);
      if (get(partie, 'id') === idPartie) {
        // map groups
        const groups = map(get(partie, 'groups'), groupsItem => getGroupItem(groupsItem));
        set(partie, 'groups', groups);
      }
      return partie;
    });

    return newData;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setShowGroup: ${e.stack}`);
  }
  return data;
};

/**
 * data partie item transform
 * @param {*} param0
 */
const newPartie = ({ data, schemaPartie }) => {
  try {
    // get last sequence of question
    const sequenceLastQuestion = getLastSequenceOfQuestions({ data });
    const partieRef = `party_${uuidv4()}`;

    // Update path
    const updatePath = find => {
      const newFind = { ...find };

      if (newFind.condition) {
        const cond = JSON.parse(newFind.condition);

        if (cond?.party?.ref) {
          newFind.condition = JSON.stringify({ ...cond, party: { ...cond.party, ref: partieRef } });
        }
      }

      if (newFind.find) {
        newFind.find = updatePath(newFind.find);
      }

      return newFind;
    };

    // Update partyRef in find path
    const updatePartyRefInPath = path => {
      const newPath = { ...path };

      if (newPath.find) {
        newPath.find = updatePath(newPath.find);
      }

      return newPath;
    };

    // get question item
    const getQuestionItem = (questionsItem, index) => {
      // Remove previous party_id from code added from SalesRoutes/Transform/QuotationBlock/index.js
      const question = { ...questionsItem };
      const code = get(question, 'code', '').replace(/_party_.*/g, '');
      const codeQuestion = `${code}_${partieRef}`;
      const sequenceQuestion = sequenceLastQuestion + index;
      const webInput = get(question, 'custom_resources.web_input');
      const path = updatePartyRefInPath(question.path);

      set(question, 'code', codeQuestion);
      set(question, 'sequence', sequenceQuestion);
      set(question, 'webInput', webInput);
      set(question, 'path', path);

      return question;
    };

    // get area item
    const getAreaItem = areasItem => {
      const idAreas = `${uuidv4()}`;
      const questionsAreas = map(get(areasItem, 'questions'), (questionsItem, index) =>
        getQuestionItem(questionsItem, index)
      );
      // area
      const area = areasItem;
      set(areasItem, 'id', idAreas);
      set(areasItem, 'questions', questionsAreas);
      return area;
    };

    // get group item
    const getGroupItem = groupsItem => {
      const idGroup = `${uuidv4()}`;
      const areasGroup = map(get(groupsItem, 'areas'), areasItem => getAreaItem(areasItem));
      // group
      const group = groupsItem;
      set(group, 'id', idGroup);
      set(group, 'areas', areasGroup);
      return group;
    };

    // get clone of partie item
    const partieClone = cloneDeep(schemaPartie);
    set(partieClone, 'id', `${uuidv4()}`);
    const partie = get(partieClone, 'partie');
    set(partie, 'ref', partieRef);
    // get groups
    const groups = map(get(partieClone, 'groups'), groupsItem => getGroupItem(groupsItem));
    //
    set(partieClone, 'partie', partie);
    set(partieClone, 'groups', groups);

    return partieClone;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`newPartie: ${e.stack}`);
  }
  return schemaPartie;
};

/**
 * add ayant droit
 */
const addPartie = ({ data, schemaPartie }) => {
  try {
    const itemData = newPartie({ data, schemaPartie });
    if (!checkIsNull(itemData)) {
      const newData = concat(data, [itemData]);
      return newData;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`addPartie: ${e.stack}`);
  }
  return data;
};

/**
 * set value show Question
 * @param {*} code
 * @param {*} show
 */
const setValueShowQuestion = ({ data, idPartie, idGroup, idArea, code, value, show = undefined }) => {
  try {
    // get question item
    const getQuestionItem = questionsItem => {
      const question = cloneDeep(questionsItem);
      if (code === get(question, 'code')) {
        // set value
        set(question, 'value', value);
        // set show
        if (!checkIsNull(show)) {
          set(question, 'show', show);
        }
      }
      return question;
    };

    // get area item
    const getAreaItem = areasItem => {
      const area = areasItem;
      if (idArea === get(area, 'id')) {
        // map questions
        const questionsArea = map(get(area, 'questions'), questionsItem => getQuestionItem(questionsItem));
        set(area, 'questions', questionsArea);
      }
      return area;
    };

    // get group item
    const getGroupItem = groupsItem => {
      const group = cloneDeep(groupsItem);
      if (idGroup === get(group, 'id')) {
        // map areas
        const areas = map(get(group, 'areas'), areasItem => getAreaItem(areasItem));
        set(group, 'areas', areas);
      }
      return group;
    };

    // get partie item
    const getPartieItem = partiesItem => {
      const partie = cloneDeep(partiesItem);
      if (get(partie, 'id') === idPartie) {
        // map groups
        const groups = map(get(partie, 'groups'), groupsItem => getGroupItem(groupsItem));
        set(partie, 'groups', groups);
      }
      return partie;
    };

    // map parties
    const newData = map(data, partiesItem => getPartieItem(partiesItem));

    return newData;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setValueShowQuestion: ${e.stack}`);
  }
  return data;
};

/**
 * Reducer
 * @param {*} state
 * @param {*} action
 */
const reducer = (state, action) => {
  try {
    const { type } = action;
    const newState = cloneDeep(state);
    switch (type) {
      //
      case types.SET_VALUE_SHOW_QUESTION: {
        const { idPartie, idGroup, idArea, code, value, show, setFieldValue } = action;
        // set value question
        const newData = setValueShowQuestion({
          data: get(state, 'data'),
          idPartie,
          idGroup,
          idArea,
          code,
          value,
          show,
        });
        set(newState, 'data', newData);
        set(newState, 'codeLastQuestionEdited', code);
        // set value Formik
        setFieldValue(code, value);
        break;
      }
      case types.SET_VALUE_QUESTION: {
        const { idPartie, idGroup, idArea, code, value, setFieldValue } = action;
        // set value question
        const newData = setValueShowQuestion({
          data: get(state, 'data'),
          idPartie,
          idGroup,
          idArea,
          code,
          value,
        });
        set(newState, 'data', newData);
        set(newState, 'codeLastQuestionEdited', code);
        // set value Formik
        setFieldValue(code, value);
        break;
      }
      case types.SET_SHOW_GROUP: {
        const { idPartie, idGroup } = action;
        // set show group by idPartie idGroup
        const newData = setShowGroup({ data: get(state, 'data'), idPartie, idGroup });
        set(newState, 'data', newData);
        break;
      }
      case types.SET_SHOW_PARTIE: {
        const { id } = action;
        // set show partie by id
        const newData = setShowPartie({ data: get(state, 'data'), id });
        set(newState, 'data', newData);
        break;
      }
      case types.REMOVE_PARTIE: {
        const { id } = action;
        // remove partie by id
        const newData = removePartie({ data: get(state, 'data'), id });
        set(newState, 'data', newData);
        break;
      }
      case types.ADD_PARTIE: {
        // remove partie by id
        const newData = addPartie({ data: get(state, 'data'), schemaPartie: get(state, 'schemaPartie') });
        set(newState, 'data', newData);
        break;
      }
      case types.SET_CODE_FIRST_ERROR: {
        // remove partie by id
        const { codeFirstError } = action;
        set(newState, 'codeFirstError', codeFirstError);
        break;
      }
      case types.UPDATE: {
        const { data } = action;
        return data;
      }
      default:
        // eslint-disable-next-line no-console
        console.error(`Unexpected action`);
        return state;
    }

    // console.log('newState', newState);
    return newState;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`reducer: ${e.stack}`);
  }
  return state;
};

export default reducer;
